import { CodeDescription } from "./code-description-dto";

export class Race {
    getRaceListing(): CodeDescription[] {
        return [
            { "Code": "American Indian or Alaska Native", "Description": "American Indian or Alaska Native" },
            { "Code": "Asian", "Description": "Asian" },
            { "Code": "Black or African-American", "Description": "Black or African-American" },
            { "Code": "Hispanic or Latino", "Description": "Hispanic or Latino" },
            { "Code": "Native Hawaiian or Pacific Islander", "Description": "Native Hawaiian or Pacific Islander" },
            { "Code": "White", "Description": "White" },
            { "Code": "U", "Description": "Unspecified" }
        ]
    }
}
